import React, { useState, useEffect } from 'react';
import Main from '../../../component/Main.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const BdTongAvgZaeSil = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchGrdc: '',
        searchLoca: '',
        searchCheck1: '',
    });

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newParams = {
            ...searchParams,
            [name]: type === 'checkbox' ? (checked ? "1" : "") : value
        };
        setSearchParams(newParams);
    };


    const dataHead = ['의료기관명', '종별', '지역', '기관수', '환자수', '병상이용률(%)', '퇴실일시 미입력환자', '응급실병상수'];
    const dataColumn = ['TNAME', 'EMCTYPE', 'EMCLOCA', 'EMCCOUNT', 'RECCOUNT', 'RATIO', 'MCOUNT', 'BEDCNT'];
    const apiCall = '/ptmiapi/hospAft/bdtongavgzaesillist.do';
    const apiCntCall = '';
    const searchParamsAdditional = {};
    const excelFileName = "병상이용률";
    const excelHead = [];
    const mergeConfig = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    const formatDataList = (dataList) => {
        return dataList.map(item => {
            const newItem = {};

            for (const key in item) {
                const value = item[key];
                if (typeof value === 'number') {
                    newItem[key] = value.toLocaleString();
                } else if (!isNaN(value) && value !== null && value !== '') {
                    const parsed = Number(value);
                    if (!isNaN(parsed)) {
                        newItem[key] = parsed.toLocaleString();
                    } else {
                        newItem[key] = value;
                    }
                } else {
                    newItem[key] = value;
                }
            }
            return newItem;
        });
    };

    useEffect(() => {
        if (state.dataList.length > 0 && typeof state.dataList[0]['RECCOUNT'] === 'number') {
            const formatted = formatDataList(state.dataList);
            setState(prev => ({ ...prev, dataList: formatted }));
        }
    }, [state.dataList]);

    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width="25%" />
                        <col width="25%" />
                        <col width="25%" />
                        <col width="25%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={false}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>내원일시</th>
                            <td colSpan="3">
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                />
                                ~
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                                <div>
                                    <span>
                                        <input type="checkbox" id="searchCheck1" name="searchCheck1" checked={searchParams.searchCheck1 === '1'} onChange={handleInputChange} />
                                        <label htmlFor="searchCheck1">진료외 방문 (챠트복사, 경유를 위한 접수) 제외</label>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
        </Main>
    )
}

export default BdTongAvgZaeSil;